import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import GameLeadProp from '../propTypes/gameLeadProp';
import translate from '../../../commonComponents/translate';
import { LEAD_STATUS } from '../../../services/utilityFunctions';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';

const LEAD_DETAILS_ACTION = {
  WIN: 'win',
  LOSE: 'lose',
  ACCEPT_OWNER: 'accept',
  REFUSE_OWNER: 'refuse',
  TAKE: 'take',
};

const ACTION_TYPE = {
  WIN_LOSE: 'win_lose',
  TAKE: 'take',
  ACCEPT_REFUSE: 'accept_refuse',
};

function LeadActions({ t, lead, onAction }) {
  const { _id: loggedId } = useContext(LoggedUserContext).loggedUser;

  const actionType = (() => {
    if (lead.status === LEAD_STATUS.NO_OWNER && lead.user._id !== loggedId) {
      return ACTION_TYPE.TAKE;
    }

    if (
      lead.status === LEAD_STATUS.WAITING_OWNER &&
      lead.owner &&
      lead.owner._id === loggedId
    ) {
      return ACTION_TYPE.ACCEPT_REFUSE;
    }

    if (
      lead.status !== LEAD_STATUS.WON &&
      lead.status !== LEAD_STATUS.LOST &&
      (lead.user._id === loggedId ||
        (lead.owner && lead.owner._id === loggedId))
    ) {
      return ACTION_TYPE.WIN_LOSE;
    }

    return null;
  })();

  return (
    <div className="lead-actions">
      {actionType === ACTION_TYPE.WIN_LOSE && (
        <>
          <button
            type="button"
            className="btn btn-success m-btn--pill m-btn--wide loader-button"
            onClick={() => onAction(LEAD_DETAILS_ACTION.WIN)}
          >
            {t('leadDetails_leadWon')}
          </button>
          <button
            type="button"
            className="btn btn-danger m-btn--pill m-btn--wide loader-button"
            onClick={() => onAction(LEAD_DETAILS_ACTION.LOSE)}
          >
            {t('leadDetails_leadLost')}
          </button>
        </>
      )}
      {actionType === ACTION_TYPE.ACCEPT_REFUSE && (
        <>
          <button
            type="button"
            className="btn btn-success m-btn--pill m-btn--wide loader-button"
            onClick={() => onAction(LEAD_DETAILS_ACTION.ACCEPT_OWNER)}
          >
            {t('leadDetails_acceptLead')}
          </button>
          <button
            type="button"
            className="btn btn-danger m-btn--pill m-btn--wide loader-button"
            onClick={() => onAction(LEAD_DETAILS_ACTION.REFUSE_OWNER)}
          >
            {t('leadDetails_refuseLead')}
          </button>
        </>
      )}
      {actionType === ACTION_TYPE.TAKE && (
        <button
          type="button"
          className="btn btn-dynamic m-btn--pill m-btn--wide loader-button"
          onClick={() => onAction(LEAD_DETAILS_ACTION.TAKE)}
        >
          {t('leadDetails_takeLead')}
        </button>
      )}
    </div>
  );
}

LeadActions.propTypes = {
  t: PropTypes.func.isRequired,
  lead: PropTypes.shape(GameLeadProp.propType).isRequired,
  onAction: PropTypes.func.isRequired,
};

export default translate(LeadActions);
export { LEAD_DETAILS_ACTION };
